<template>
  <v-base-card>
    <template v-slot:heading>
      ご利用環境
    </template>
    <template v-slot:content>
      <!-- 動作環境チェック -->
      <h5 class="title-blue" style="margin-bottom:10px;">
        動作環境チェック
      </h5>
      <p class="bold mx-0 mb-0">以下のチェック項目を確認してください。</p>
      <p class="bold mx-0 mb-0">※判定にjavascriptを使用していますので、ブラウザのjavascriptの設定をON（許可）にしてください。</p>
      <v-simple-table class="mt-5">
        <template v-slot:default>
          <tbody>
            <tr>
              <th style="width:15%;"> チェック項目</th>
              <th>必要な環境</th>
              <th>お客様のご利用環境</th>
            </tr>
            <tr>
              <td style="text-align:left;vertical-align:middle;border-left: thin solid rgba(0, 0, 0, 0.12);">1.OS</td>
              <td class="pt-4" style="text-align:left;border-left: thin solid rgba(0, 0, 0, 0.12);">
                <p style="font-weight:bold;font-size:15px;margin-bottom:5px;border-bottom:solid 1px #ccc;">PC</p>
                <span style="font-weight:bold;font-size:15px;">Windows</span>
                <br>
                Windows11
                <br>
                <span style="font-weight:bold;font-size:15px;">Mac</span>
                <br>
                Mac10.10以降（Mac10.13【推奨】）
                <br>
                <br>
              </td>
              <td style="text-align:left;font-size:15px;border-right: thin solid rgba(0, 0, 0, 0.12);border-left: thin solid rgba(0, 0, 0, 0.12);">
                <span>ご利用のOSは <b style='color:blue;'>{{osName}}</b> です。</span>
              </td>
            </tr>
            <tr>
              <td style="text-align:left;vertical-align:middle;border-left: thin solid rgba(0, 0, 0, 0.12);border-bottom: thin solid rgba(0, 0, 0, 0.12);border-: thin solid rgba(0, 0, 0, 0.12)">
                 2.ブラウザ
              </td>
              <td class="pt-4" style="text-align:left;border-bottom: thin solid rgba(0, 0, 0, 0.12);border-left: thin solid rgba(0, 0, 0, 0.12);">
                <p style="font-weight:bold;font-size:15px;margin-bottom:5px;border-bottom:solid 1px #ccc;">PC</p>
                <span style="font-weight:bold;font-size:15px;">Windows</span>
                <br>
                Chrome(最新版)【推奨】
                <br>
                Edge(最新版)
                <br>
                <span style="font-weight:bold;font-size:15px;">Mac</span>
                <br>
                Safari(最新版)
                <br>
                <br>
              </td>
              <td style="text-align:left;font-size:15px;border-bottom: thin solid rgba(0, 0, 0, 0.12);border-right: thin solid rgba(0, 0, 0, 0.12);border-left: thin solid rgba(0, 0, 0, 0.12);">
                <span>
                  <span>閲覧ブラウザは<b style="color:blue;">{{browserName}}</b></span>
                  <br>
                <span v-if="browserVersion">バージョンは<b style="color:blue;">{{browserVersion}}</b>です。</span>
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- 通信速度チェック -->
      <h5 class="title-blue mt-8" style="margin-bottom:10px;">
        通信速度チェック
      </h5>
      <p class="mb-0">「診断スタート」ボタンをクリックし、通信速度を確認してください。ご利用の端末や環境によって、チェックに時間がかかる場合があります。</p>
      <p class="mb-0">
        ※通信速度が
        <span style="font-weight:bold;">
          【5.00Mbps以上】
        </span>
         がスムーズに動画も閲覧できる推奨回線速度です。
      </p>

      <v-row>
        <v-btn
          class="ml-3 mt-3"
          small
          color="secondary"
          @click.stop="speedtest"
        >
          診断スタート
        </v-btn>
      </v-row>

    </template>
  </v-base-card>
</template>

<script>

import VBaseCard from '@/components/molecules/BaseCard'

export default {
  components: {
    VBaseCard,
  },

  data() {
    return {
      osName: null,
      browserName: null,
      browserVersion: null,
    }
  },

  beforeDestroy() {
    // タブ名を設定
    document.title = 'ゲットスルー2600システム';
  },

  mounted() {
    // タブ名を設定
    document.title = '動作環境確認ページ';

     var os, ua = navigator.userAgent;
     var version

    // OS
    if (ua.match(/Win(dows )?NT 10\.0/)) {
      this.osName = "Windows 10以降";        // Windows 10 の処理
      if (navigator.userAgentData) {
        navigator.userAgentData.getHighEntropyValues(["platformVersion"])
          .then(uaData => {
            var majorVersion = parseInt(uaData.platformVersion.split('.')[0]);
            if (majorVersion >= 13) {
              this.osName = "Windows 11";
            } else {
              this.osName = "Windows 10";
            }
          });
      }
    }
    else if (ua.match(/Win(dows )?NT 6.3/)) {
      this.osName = "Windows 8.1";       // Windows 8.1 の処理
    }
    else if (ua.match(/Win(dows )?NT 6.2/)) {
      this.osName = "Windows 8";       // Windows 8 の処理
    }
    else if (ua.match(/Win(dows )?NT 6.1/)) {
      this.osName = "Windows 7";       // Windows 7 の処理
    }
    else if (ua.match(/Win(dows )?NT 6.0/)) {
      this.osName = "Windows Vista";       // Windows Vista の処理
    }
    else if (ua.match(/Win(dows )?NT 5.2/)) {
      this.osName = "Windows Server 2003";     // Windows Server 2003 の処理
    }
    else if (ua.match(/Win(dows )?(NT 5.1|XP)/)) {
      this.osName = "Windows XP";        // Windows XP の処理
    }
    else if (ua.match(/Win(dows)? (9x 4.90|ME)/)) {
      this.osName = "Windows ME";        // Windows ME の処理
    }
    else if (ua.match(/Win(dows )?(NT 5.0|2000)/)) {
      this.osName = "Windows 2000";        // Windows 2000 の処理
    }
    else if (ua.match(/Win(dows )?98/)) {
      this.osName = "Windows 98";        // Windows 98 の処理
    }
    else if (ua.match(/Win(dows )?NT( 4.0)?/)) {
      this.osName = "Windows NT";        // Windows NT の処理
    }
    else if (ua.match(/Win(dows )?95/)) {
      this.osName = "Windows 95";        // Windows 95 の処理
    }
    else if (ua.match(/iPhone|iPad/)) {
      this.osName = "iOS";         // iOS (iPhone, iPod touch, iPad) の処理
      version = ua.split('OS ')[1].split(' ')[0];
      this.osName = os + version;
    }
    else if (ua.match(/Mac|PPC/)) {
      this.osName = "Mac OS";          // Macintosh の処理
    }
    else if (ua.match(/Android ([.\d]+)/)) {
      this.osName = "Android " + RegExp.$1;      // Android の処理
      version = parseFloat(ua.slice(ua.indexOf("Android")+8));
      this.osName = os + version;
    }
    else if (ua.match(/Linux/)) {
      this.osName = "Linux";         // Linux の処理
    }
    else if (ua.match(/^.*\s([A-Za-z]+BSD)/)) {
      this.osName = RegExp.$1;         // BSD 系の処理
    }
    else if (ua.match(/SunOS/)) {
      this.osName = "Solaris";         // Solaris の処理
    }
    else {
      this.osName = "N/A";         // 上記以外 OS の処理
    }

    var agent = navigator.userAgent;
    var cutSt;
    var cutEd;

    ua = {
      isIE: /MSIE/.test(agent),
      isIE11: /Trident/.test(agent),
      isEdge: /Edg/.test(agent) || /Edge/.test(agent),
      isFireFox: /Firefox/.test(agent),
      isChrome: /Chrome/.test(agent),
      isOpera: /OPR/.test(agent)
    };
    ua.isSafari = /Safari/.test(agent) && !ua.isChrome;

    if (ua.isEdge) {
      this.browserName = 'Edge'
      this.browserVersion = agent.split('Edg/')[0] ? agent.split('Edg/')[1] : agent.split('Edge/')[1]
    } else if (ua.isIE || ua.isIE11) {
      this.browserName = 'IE'
      this.browserVersion = '11'
    } else if (ua.isFireFox) {
      cutSt = agent.indexOf("Firefox");
      cutEd = agent.length;
      this.browserName = 'Firefox'
      this.browserVersion = agent.substring(cutSt+8,cutEd);
    } else if (ua.isOpera) {
      cutSt = agent.indexOf("OPR");
      cutEd   = agent.length
      this.browserName = 'Opera'
      this.browserVersion = agent.substring(cutSt+4,cutEd);
   } else if (ua.isChrome) {
      cutSt = agent.indexOf("Chrome");
      cutEd   = agent.indexOf(" ",cutSt);
      this.browserName = 'Chrome'
      this.browserVersion = agent.substring(cutSt+7,cutEd);
   } else if (ua.isSafari) {
      cutSt = agent.indexOf("Version");
      cutEd   = agent.indexOf(" ",cutSt);
      this.browserName = 'Safari'
      this.browserVersion = agent.substring(cutSt+8,cutEd);
    } else {
      this.browserName = '推奨ブラウザではありません'
    }
  },

  methods: {
    async speedtest() {
      const start = (new Date()).getTime();
      const res = await fetch(`${window.location.origin}/measure_file.png?time=${start}`, { cache: 'no-store' });
      const blob = await res.blob();
      const end = (new Date()).getTime();
      const sec = (end - start) / 1000;
      const bytesPerSec = blob.size / sec;
      const speed = bytesPerSec * 8 / 1000 / 1000;
      alert((Math.round(speed * 100) / 100).toFixed(2) + 'M bps');
    }
  }
}
</script>

<style lang="stylus" scoped>
th
  background-color #2065b5
  color white
  font-weight bold
  text-align center !important
  border-right 0.5px solid white

h5
  color #0079e8

p
  font-size 13px

</style>
